import React from "react";
import ClientFooter from "./ClientFooter";
const PrivacyPolicy = () => {
    return (
        <>
            <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inner text-center">
                                <h2 className="title">Privacy Policy</h2>
                                <ul className="page-list">
                                    <li className="rbt-breadcrumb-item">
                                        <a href="index.html">Home</a>
                                    </li>
                                    <li>
                                        <div className="icon-right">
                                            <i className="feather-chevron-right" />
                                        </div>
                                    </li>
                                    <li className="rbt-breadcrumb-item active">Privacy Policy</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rbt-overlay-page-wrapper">
                <div className="rbt-putchase-guide-area breadcrumb-style-max-width rbt-section-gapBottom">
                    <div className="rbt-article-content-wrapper">
                        <div className="content  mt-5">
                            <div className="mb-4">
                                <p><strong>Effective Date:</strong> 11/05/2025</p>
                                <p><strong>Company Name:</strong> Day Trading Tactics</p>
                                <p><strong>Address:</strong> Mogappair, Chennai, India</p>
                                <p><strong>Contact Email:</strong> venkateshan@daytradingtactics.in</p>
                            </div>

                            <h4>1. Welcome</h4>
                            <p>
                                At Day Trading Tactics, we value your privacy and are committed to protecting your
                                personal information. This Privacy Policy explains what information we collect, why we
                                collect it, and how we use it. By using our website and services, you agree to this policy.
                            </p>

                            <h4>2. What Information We Collect</h4>
                            <p>We collect the following types of information:</p>
                            <ul>
                                <li>Personal Info: Your name, email address, phone number.</li>
                                <li>Account Info: Username, password, profile settings.</li>
                                <li>Payment Info: Details related to your payment method (handled securely via Razorpay or other gateways).</li>
                                <li>Usage Info: IP address, browser type, location, time spent on pages, clicks, etc.</li>
                                <li>Profile Picture: This helps us verify your identity and protect your account</li>
                                <li>Cookies: Small data files stored on your browser to help us improve your experience.</li>
                            </ul>

                            <h4>3. How We Collect Your Info</h4>
                            <p>We collect information in a few ways:</p>
                            <ul>
                                <li>When you register or create an account.</li>
                                <li>When you purchase a course or make a payment.</li>
                                <li>When you contact us through forms, email, or chat.</li>
                                <li>Through cookies and analytics tools when you browse our website.</li>
                            </ul>

                            <h4>4. Why We Collect Your Info</h4>
                            <p>We collect your data to:</p>
                            <ul>
                                <li>Provide access to our trading courses and services.</li>
                                <li>Send updates, confirmations, or offers (only if you allow).</li>
                                <li>Understand how users use our website so we can improve it.</li>
                                <li>Process payments and deliver receipts securely.</li>
                                <li>Comply with legal or tax-related obligations.</li>
                            </ul>

                            <h4>5. How We Keep Your Info Safe</h4>
                            <p>We care about your safety. We use secure methods like:</p>
                            <ul>
                                <li>SSL encryption (padlock icon in the browser).</li>
                                <li>Safe payment gateways like Razorpay.</li>
                                <li>Firewalls and access restrictions on data storage.</li>
                                <li>Regular checks and updates to our systems.</li>
                            </ul>
                            <p>But remember: No system is 100% foolproof online. Please use strong passwords and keep your login info private.</p>

                            <h4>6. Cookies Policy</h4>
                            <p>Cookies help us serve you better. They:</p>
                            <ul>
                                <li>Remember your login session.</li>
                                <li>Show content based on your preferences.</li>
                                <li>Help us track website traffic and performance.</li>
                            </ul>
                            <p>You can disable cookies anytime in your browser settings, but some features may not work properly.</p>

                            <h4>7. Who We Share Your Data With</h4>
                            <p>We do not sell or trade your personal info.</p>
                            <p>We only share it with:</p>
                            <ul>
                                <li>Trusted partners like Razorpay (for payments), Google Analytics (for website traffic).</li>
                                <li>Legal authorities, if required by law or to protect our rights.</li>
                            </ul>

                            <h4>8. Your Rights</h4>
                            <p>You have the right to:</p>
                            <ul>
                                <li>See what data we have about you.</li>
                                <li>Correct or update your data.</li>
                                <li>Delete your account or ask us to erase your info.</li>
                                <li>Unsubscribe from marketing emails anytime.</li>
                            </ul>
                            <p>Just email us at venkateshan@daytradingtactics.in for any of the above.</p>

                            <h4>9. Children's Privacy</h4>
                            <p>Our content is meant for people 18 years and older. We don't knowingly collect data from children. If you think a child has shared info with us, let us know immediately.</p>

                            <h4>10. Third-Party Links</h4>
                            <p>Our website might have links to YouTube, Instagram, LinkedIn, etc. These sites have their own privacy policies. We're not responsible for how they handle your data.</p>

                            <h4>11. Updates to this Policy</h4>
                            <p>We may update this policy from time to time. If we do, we'll post the changes here and update the date at the top. For major updates, we'll notify you by email or a notice on our website.</p>
                        </div>
                    </div>
                </div>
            </div>
            <ClientFooter/>
        </>
    );
};

export default PrivacyPolicy;
